<div class="content">
  <div class="body">
    <div class="body-content">
      <span class="page-title">Compass Library</span>
      <div class="search-input-container">
        <input #search type="text" class="search-input" placeholder="Search for compass, condition, or provider..." [disabled]="isLoading()" [(ngModel)]="searchInputValue" />
        <button mat-button class="text-button search-button" disabled>
          <img src="assets/content-icon/ic-02.svg" class="icon" />
        </button>
      </div>
      <div class="compass-group">
        <div class="compass-group-title-line">
          <span class="text">Owned compasses</span>
          <a mat-button href="https://huddyhealth.com/chronic-conditions/" target="_blank" class="button text-button">
            <img src="assets/content-icon/ic-04.svg" class="icon" />
            <span class="button-text">Discover compasses</span>
          </a>
        </div>
        <div class="empty-state">Nothing to show</div>
        <div #compassCardsContainer class="compass-group-grid" [style]="compassColumnStyles">
          <div class="compass skeleton skeleton-animation" *ngFor="let compass of getLoadingArray()"></div>
          <div class="compass owned" *ngFor="let compass of manageableCompasses" [ngClass]="{hidden: !matchesFilter(compass)}">
            <span class="compass-letters">{{getLetters(compass.name)}}</span>
            <div class="compass-text">
              <span class="compass-title">{{compass.name}} (version {{compass.version}})</span>
              <span *ngIf="isMultiProvider()" class="compass-desc">{{compass.providerName}}</span>
              <span class="compass-desc">{{compass.description}}</span>
            </div>
            <div class="compass-buttons">
              <button mat-button  class="compass-button" (click)="open(compass)">Open</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>